import { render } from "./EconomyDeathsGlobalPrices.vue?vue&type=template&id=63e90c90&ts=true"
import script from "./EconomyDeathsGlobalPrices.vue?vue&type=script&lang=ts"
export * from "./EconomyDeathsGlobalPrices.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__